import { Modal } from 'antd';
import { styled } from 'styled-components';

export const ModalWrapper = styled(Modal)`
  .ant-modal-header {
    padding: 20px 24px 0;
    border-bottom: none;
  }
  .file-icon {
    background: url(//static.szlcsc.com/ecp/assets/web/common/images/list_item_icon20181217.png);
    background-position: -20px 162px;
  }
`;
